import type { OwaDate } from '../../../schema';
import { RokuyouDay } from '../../../intl/RokuyouDay';
import getRokuyouDay from './getRokuyouDay';
import { assertNever } from 'owa-assert';

export default function getIntlDateRokuyou(date: OwaDate): string {
    // A bit of confusion since it's called a "day" but it's used here as a date
    const rokuyouDay = getRokuyouDay(date);

    // These are non-localized strings
    switch (rokuyouDay) {
        case RokuyouDay.Senshou:
            return '先勝';
        case RokuyouDay.Tomobiki:
            return '友引';
        case RokuyouDay.Sakimake:
            return '先負';
        case RokuyouDay.Butsumetsu:
            return '仏滅';
        case RokuyouDay.Taian:
            return '大安';
        case RokuyouDay.Shakku:
            return '赤口';
        default:
            assertNever(rokuyouDay);
    }
}
